<template>
  <div class="pokemon has-text-left">
    <span class="is-hidden">{{identifier}} {{TypeEfficacy}}</span>
    <div
      id="details"
      v-if="details !== null"
    >
      <!-- <pre class="has-text-black is-size-7">{{details}}</pre> -->

      <div class="columns is-variable is-8">
        <div class="column pokemonImage">
          <img
            :src="$pkImg('big', details.identifier, details.species_id)"
            alt=""
            @error="$imgErr($event, 'sprite')"
          >
          <div
            class="forms"
            v-if="details.forms"
          >
            <b-tooltip
              :class="{'active': details.id === details.species_id}"
              :label="details.species_name"
              type="is-dark"
            >
              <div @click="goPokemon(details.species_identifier)">
                original
              </div>
            </b-tooltip>
            <br>
            <!-- <b-tooltip :class="{'active': details.id === details.species_id}" :label="details.species_name" type="is-dark" v-if="details.forms[0].is_battle_only == 1">
              <img :src="$pkImg('sprite-small', details.species_identifier)" :alt="details.species_identifier" width="40" height="30" @click="goPokemon(details.species_identifier)">
            </b-tooltip> -->
            <b-tooltip
              :class="{'active': details.id === f.pokemon_id}"
              :label="f.form_name"
              type="is-dark"
              v-for="(f, fi) in details.forms"
              :key="fi"
            >
              <img
                :src="$pkImg('sprite-small', f.pokemon_identifier)"
                :alt="f.pokemon_identifier"
                width="40"
                height="30"
                @click="goPokemon(f.pokemon_identifier)"
              >
            </b-tooltip>
          </div>
        </div>
        <div class="column pokemonDetails is-6">
          <h1 class="title pokemonName">
            {{details.id === details.species_id ? details.species_name : details.name}}
            <span class="tag">{{details.species_name}} introduced in gen. {{details.generation_id}}</span>
          </h1>
          <p class="subtitle latestDexEntry is-size-6">
            {{details.latest_pokedex_entry}}
          </p>
          <p class="types">
            <pokemon-type
              :id="id"
              large
              v-for="id in $commaStringToArray(details.type_id)"
              :key="id"
            ></pokemon-type>
          </p>
          <!-- <p class="is-size-6 has-text-weight-light">{{details.species_name}} introduced in gen. {{details.generation_id}}</p> -->
          <br>
          <div class="columns is-variable is-1 information">
            <div class="column">
              <nav class="panel">
                <p class="panel-block is-active">
                  <span>National Dex:</span>&nbsp;#{{details.id}}
                </p>
                <p class="panel-block is-active">
                  <span>Weight:</span>&nbsp;{{$addDecimal(details.weight, 1)}} kg
                </p>
                <p class="panel-block is-active">
                  <span>Height:</span>&nbsp;{{$addDecimal(details.height, 1)}} m
                </p>
                <p class="panel-block is-active">
                  <span>Base experience:</span>&nbsp;{{details.base_experience}}
                </p>
                <p class="panel-block is-active">
                  <span>Base happiness:</span>&nbsp;{{details.base_happiness}}
                </p>
              </nav>
            </div>
            <div class="column">
              <nav class="panel">
                <p class="panel-block is-active">
                  <span>EV yield:</span>&nbsp;{{evYield.map((v) => v.amount + ' ' + statNames[v.name]).join(', ')}}
                </p>
                <p class="panel-block is-active">
                  <span>Capture rate:</span>&nbsp;{{details.capture_rate}}
                </p>
                <p class="panel-block is-active">
                  <span>Growth rate:</span>&nbsp;{{details.growth_rate}}
                </p>
                <p class="panel-block is-active">
                  <span>Hatch counter:</span>&nbsp;{{details.hatch_counter}} ({{details.hatch_counter * 255}} steps)
                </p>
                <p class="panel-block is-active">
                  <span>Gender rate:</span>&nbsp;{{$genderRateDescription(details.gender_rate)}}
                </p>
                <!-- <p class="panel-block is-active">
                  <span>Has gender differences:</span>&nbsp;{{details.has_gender_differences == 1? 'yes' : 'no'}}
                </p>
                <p class="panel-block is-active">
                  <span>Is baby Pokémon:</span>&nbsp;{{details.is_baby == 1? 'yes' : 'no'}}
                </p> -->
              </nav>
            </div>
          </div>

          <p class="is-size-6 is-marginless">Abilities</p>
          <div
            v-for="(a, j) in details.abilities"
            :key="j"
          >
            <router-link
              :to="'/ability/' + ab.identifier"
              v-for="(ab, i) in AbilitiesList"
              :key="i"
              v-if="ab.id == a.ability_id"
            >
              <span class="is-size-5 has-text-primary">{{ab.name}}</span>
              <span
                v-if="abilityIsHidden(ab.pokemonHidden) !== -1"
                class="has-text-lime"
              >[Hidden]</span>
              <span class="has-text-white">- {{ab.description}}</span>
            </router-link>
          </div>
        </div>
      </div>

      <!-- <br> -->
      <div class="columns is-variable is-8">
        <div class="column stats">
          <h2 class="title">Stats</h2>
          <p class="subtitle">Base stats</p>

          <div
            class="stat"
            :data-stat-name="s.identifier"
            v-for="(s, i) in details.stats"
            :key="i"
          >
            <div
              class="columns"
              :class="getStatClass(s)"
            >
              <div class="column is-2">
                {{statNames[s.identifier].toUpper()}}
              </div>
              <div class="column is-1">
                {{s.base_stat}}
              </div>
              <div class="column">
                <progress
                  class="progress is-white"
                  :value="s.base_stat"
                  :max="tempMax[s.stat_id]"
                ></progress>
              </div>
            </div>
          </div>
          <br>
          <div>
            <h2 class="title is-size-5">Total: {{statsTotal}}</h2>
          </div>
        </div>

        <div
          class="column type-efficacy"
          v-if="typeDefenses.data"
        >
          <h2 class="title">Defense</h2>
          <p class="subtitle">Type effectiveness</p>
          <div
            class="type-defense"
            :class="'t-' + v.power"
            v-for="(v, key) in typeDefenses.display"
            :key="key"
          >
            <div class="columns">
              <div class="column is-1">
                <span>{{v.text}}</span>
              </div>
              <div class="column">
                <pokemon-type
                  :id="id"
                  :power="v.power"
                  v-for="(d, id) in typeDefenses.data"
                  :key="id"
                  v-if="d == (v.power / 100)"
                ></pokemon-type>
                <div class="is-clearfix"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-variable is-8">
        <div class="column moves is-6 bg-color-3"></div>
        <div class="column evolutions">
          <template v-if="evolutionChain.length">
            <h2 class="title is-marginless">Evolution Chain</h2>
            <div class="evorootchain">
              <evolution
                :pokemon="evolutionChainBase"
                class="base"
              ></evolution>
              <template class="icon reset">
                <i class="next mdi mdi-arrow-right-thick"></i>
                <evolution-chain
                  :chain="evolutionChain"
                  v-if="evolutionChain.length"
                ></evolution-chain>
              </template>
            </div>
          </template>
          <template v-else>{{details.species_name}} does not evolve</template>
        </div>
      </div>
      <div class="columns is-variable is-8">
        <div class="column moves bg-color-1">
          <h2 class="title is-marginless">Moves</h2>
          <p>Generations:</p>

          <div
            class="has-text-left"
            v-if="VersionsList && lastVersionID"
          >
            <a
              class="tag gen has-text-weight-bold"
              :class="{'is-primary has-text-black': selectedMoveVersionID === v.id}"
              @click="selectedMoveVersionID = v.id"
              v-for="(v, i) in VersionsList"
              :key="i"
            >{{gameShortNames[v.identifier]}}</a>
          </div>
          <br>
          <template v-if="MovesList && MovesMethods">
            <b-tabs type="is-boxed">
              <b-tab-item label="Level Up">
                <div
                  class="move-row"
                  v-for="(pm, i) in details.moves_simple[selectedMoveVersionID]"
                  :key="i"
                  v-if="MovesMethods[pm[moveKeyMap['method_id']]]['identifier'] === 'level-up'"
                >
                  <pokemon-move
                    :data="pm"
                    :moveKeyMap="moveKeyMap"
                  ></pokemon-move>
                </div>
              </b-tab-item>
              <b-tab-item label="TM">
                <div
                  class="move-row"
                  v-for="(pm, i) in details.moves_simple[selectedMoveVersionID]"
                  :key="i"
                  v-if="MovesMethods[pm[moveKeyMap['method_id']]]['identifier'] === 'machine'"
                >
                  <pokemon-move
                    :data="pm"
                    :moveKeyMap="moveKeyMap"
                  ></pokemon-move>
                </div>
              </b-tab-item>
              <b-tab-item label="Egg">
                <div
                  class="move-row"
                  v-for="(pm, i) in details.moves_simple[selectedMoveVersionID]"
                  :key="i"
                  v-if="MovesMethods[pm[moveKeyMap['method_id']]]['identifier'] === 'egg'"
                >
                  <pokemon-move
                    :data="pm"
                    :moveKeyMap="moveKeyMap"
                  ></pokemon-move>
                </div>
              </b-tab-item>
              <b-tab-item label="Tutor">
                <div
                  class="move-row"
                  v-for="(pm, i) in details.moves_simple[selectedMoveVersionID]"
                  :key="i"
                  v-if="MovesMethods[pm[moveKeyMap['method_id']]]['identifier'] === 'tutor'"
                >
                  <pokemon-move
                    :data="pm"
                    :moveKeyMap="moveKeyMap"
                  ></pokemon-move>
                </div>
              </b-tab-item>
            </b-tabs>
          </template>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import config from '../../../config'
import { mapGetters } from 'vuex'
import Evolution from '../../Evolution'
import EvolutionChain from '../../EvolutionChain'
import PokemonType from '../../PokemonType'
import PokemonMove from '../../PokemonMove'
import axios from 'axios'
// import yaml from 'js-yaml'

export default {
  name: 'Pokemon',
  components: {
    Evolution,
    EvolutionChain,
    PokemonType,
    PokemonMove,
  },
  data() {
    return {
      details: null,
      tempMax: { 1: 255, 2: 190, 3: 230, 4: 194, 5: 230, 6: 180 },
      typeDefenses: {
        data: null,
        display: [
          { power: 400, text: '400%', description: 'Super effective' },
          { power: 200, text: '200%', description: 'Super effective' },
          { power: 100, text: '100%', description: 'Effective' },
          { power: 50, text: '50%', description: 'Not very effective' },
          { power: 25, text: '25%', description: 'Not very effective' },
          { power: 0, text: '0', description: 'No effect' },
        ],
      },
      statNames: config.data.pokemon.stats,
      gameShortNames: config.data.games.shortNames,
      evolutionChain: [],
      selectedMoveVersionID: -1,
    }
  },
  computed: {
    lastVersionID() {
      if (!this.VersionsList.length) {
        return -2
      }
      let l = this.VersionsList.sort((a, b) => (a.id > b.id ? -1 : a.id === b.id ? 0 : 1))[0].id
      this.selectedMoveVersionID = l
      return l
    },
    moveKeyMap() {
      let keymap = {}
      this.details.moves_simple_keymap.map((k, i) => {
        Object.assign(keymap, { [k]: i })
      })
      return keymap
    },
    // generations() {
    // 	let gen = []
    // 	let games = {}
    // 	this.VersionsList.map((d) => {
    // 		if (gen.indexOf(d.generation_id) === -1) {
    // 			gen.push(d.generation_id)
    // 			games[d.generation_id] = []
    // 		}
    // 		games[d.generation_id].push(config.data.games.names[d.identifier])
    // 	})
    // 	return games
    // },
    identifier() {
      if (this.$route.params.identifier !== '') {
        this.getDetails(this.$route.params.identifier)
      }
      return this.$route.params.identifier
    },
    statsTotal() {
      let t = 0
      for (let i in this.details.stats) {
        t += parseInt(this.details.stats[i].base_stat)
      }
      return t
    },
    evolutionChainBase() {
      return this.details.evolution_chain.filter(v => {
        return isNaN(parseInt(v.evolves_from_species_id))
      })[0]
    },
    evYield() {
      let sk = Object.keys(this.details.stats)
      let ev = []
      for (let i = 0; i < sk.length; i++) {
        if (this.details.stats[sk[i]].effort > 0) {
          ev.push({
            name: this.details.stats[sk[i]].identifier,
            amount: this.details.stats[sk[i]].effort,
            id: this.details.stats[sk[i]].stat_id,
          })
        }
      }
      return ev
    },
    ...mapGetters({
      PokemonTypes: 'pokemon/types',
      TypeEfficacy: 'pokemon/typeEfficacy',
      AbilitiesList: 'abilities/list',
      MovesList: 'moves/list',
      MovesMethods: 'moves/methods',
      VersionsList: 'versions/list',
    }),
  },
  mounted() {},
  methods: {
    getDetails(idn) {
      // if (this.TypeEfficacy) {} // what the actual f***

      axios
        .get('/data/json/' + idn + '.json')
        .then(response => {
          if (response.data) {
            this.details = response.data
            this.typeDefenses.data = this.getTypeEfficacy(this.details.type_id)
            this.evolutionChain = this.getEvolutionChain(this.evolutionChainBase.id)
          }
        })
        .catch(error => {
          console.log('json error')
          console.log(error)
        })
      // console.log(this.identifier)
      // console.log(this.PokemonTypes)
      // // yaml file
      // axios.get('/data/yaml/bulbasaur.yaml')
      // .then((response) => {
      // 	if (response.data) {
      // 		let t = yaml.safeLoad(response.data)
      // 		console.log(t)
      // 	}
      // })
      // .catch((error) => {
      // 	console.log('yaml error')
      // 	console.log(error)
      // })
      // json file

      // service.get('/pokemon/' + idn + '/details')
      // .then((response) => {
      // 	if (response.data) {
      // 		this.details = response.data
      // 		this.typeDefenses.data = this.getTypeEfficacy(this.details.type_id)
      // 		this.evolutionChain = this.getEvolutionChain(this.evolutionChainBase.id)
      // 	}
      // })
      // .catch((error) => {
      // 	console.log(error.response)
      // 	if (error.response && error.response.data.meta) {
      // 		if (error.response.data.meta.error_pokemon_not_found) {
      // 			alert('Couldn\'t find pokemon "' + error.response.data.meta.error_pokemon_not_found + '"')
      // 		}
      // 	}
      // })
    },
    getStatClass(stat) {
      let r = (stat.base_stat / this.tempMax[stat.stat_id]) * 100
      if (r > 45) {
        return 'is-success'
      } else if (r > 29) {
        return 'is-warning'
      } else {
        return 'is-danger'
      }
    },
    getTypeEfficacy(typeID) {
      let t = typeID.split(',')
      let tek = Object.keys(this.TypeEfficacy)
      let r = {}
      for (let id in t) {
        for (let i = 0; i < tek.length; i++) {
          if (typeof r[i + 1] === 'undefined') {
            r[i + 1] = this.TypeEfficacy[tek[i]][t[id]] / 100
          } else {
            r[i + 1] *= this.TypeEfficacy[tek[i]][t[id]] / 100
          }
        }
      }
      return r
    },
    getEvolutionChain(baseID) {
      let next = this.nextEvo(baseID)
      if (!next.length) {
        return []
      }
      for (let p = 0; p < next.length; p++) {
        let n = this.getEvolutionChain(next[p].id)
        if (n.length) {
          next[p].next = n
        }
      }
      return next
    },
    nextEvo(id) {
      return this.details.evolution_chain.filter(v => parseInt(v.evolves_from_species_id) === id)
    },
    abilityIsHidden(hiddenPokemon) {
      return hiddenPokemon.indexOf(this.details.id)
    },
    goPokemon(identifier) {
      this.$router.push('/pokemon/' + identifier)
    },
  },
}
</script>


<style lang="scss">
@import '~@/assets/css/variables.scss';

h1.pokemonName {
  font-size: 4rem;
}

.bg-color-1 {
  background-color: rgba($color: #000000, $alpha: 0.36);
}

.bg-color-2 {
  background-color: rgba($color: #000000, $alpha: 0.36);
}

.bg-color-3 {
  background-color: rgba($color: #000000, $alpha: 0.42);
}

.columns.information {
  .panel-block {
    border: none;
    padding: 2px;
  }
  p {
    // font-size: 16px;
    color: $warning;
    color: $white;
    span {
      color: $grey-light;
      // font-weight: 700;
      // font-size: 14px;
    }
  }
}

.column.pokemonImage {
  display: flex;
  justify-content: center;
  align-items: center;

  flex-flow: column wrap;

  // background-color: rgba(255,255,255,.05);
  // margin: 5px;
  // background-color:rgba($color: #fff, $alpha: .1);
  > img {
    filter: $pokemon-img-drop-shadow;
  }

  .forms {
    margin-top: 30px;
    text-align: center;
    span {
      margin: 0 2px;
      cursor: pointer;
      &:hover,
      &.active {
        border-radius: $radius;
        background-color: rgba(255, 255, 255, 0.1);
      }
    }
  }
}

.stats {
  background-color: rgba($color: #000000, $alpha: 0.1);
  .stat {
    margin: 18px 0 0;
    .columns {
      border-radius: 2px;
      $pstat: is-danger is-warning is-success is-primary;
      $pstatcolors: $danger $warning $success $primary;
      @for $i from 1 through length($pstat) {
        &.vivid.#{nth($pstat, $i)} {
          background-color: lighten(nth($pstatcolors, $i), 5%);
          color: darken(nth($pstatcolors, $i), 39%);
          .column:nth-child(2) {
            background-color: darken(nth($pstatcolors, $i), 15%);
          }
          progress {
            &::-webkit-progress-bar {
              background-color: darken(nth($pstatcolors, $i), 15%);
            }
          }
        }
        &.#{nth($pstat, $i)} {
          background-color: $grey-darker;
          color: $white;
          .column:nth-child(2) {
            background-color: $grey-dark;
          }
          progress {
            &::-webkit-progress-value {
              background-color: nth($pstatcolors, $i);
            }
            &::-webkit-progress-bar {
              background-color: $grey-dark;
            }
          }
        }
      }
      .column {
        margin-top: 6px;
        padding: 4px 12px;
        font-weight: 700;
        &:nth-child(1) {
          padding-left: 20px;
        }
        &:nth-child(2) {
          border-radius: 2px;
          margin: 5px 0;
          text-align: center;
          font-size: 18px;
          color: #fff;
        }
        progress {
          margin-top: 7px;
          height: 0.7rem;
        }
      }
    }
  }
}

.type-efficacy {
  background-color: rgba($color: #000000, $alpha: 0.2);
  > p.subtitle {
    margin-bottom: 0.8rem;
  }
  .type-defense {
    padding: 0;
    margin: 0;
    border-bottom: 1px solid $grey-dark;
    &:last-of-type {
      border-bottom: none;
    }
    .columns {
      margin: 0;
    }
    .tag {
      font-size: 14px;
      font-weight: 500;
    }
    .column {
      padding: 8px 12px;
      justify-content: left;
      span {
        vertical-align: middle;
      }
      &:nth-child(1) {
        justify-content: flex-end;
        font-size: 18px;
        text-align: center;
        font-weight: 700;
        color: $white;
      }
    }
  }
}

.evolutions {
  background-color: rgba($color: #000000, $alpha: 0.27);
  .evorootchain {
    display: flex;
    align-items: center;
    .evolution-chain {
      // width:100%;
      max-height: 400px;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      // flex-wrap: wrap;
      &.group {
        flex-flow: column wrap;
        .evolution {
          margin-bottom: 20px;
          // background-color: #f0f;
        }
      }
    }
    .evolution-group {
      display: flex;
      align-items: center;
    }
    .evolution {
      width: 110px;
      text-align: center;
      // margin-bottom: 10px;
      margin: 10px;

      // img {
      // 	filter: $pokemon-img-drop-shadow-small;
      // }

      // background-color: $grey-darker;
      background-color: rgba($color: #fff, $alpha: 0.05);
      border-radius: 5px;
      padding: 10px 5px;

      &:hover {
        background-color: $grey-dark;
      }
      > p {
        text-align: center;
        color: $white;
      }
      &:hover {
        cursor: pointer;
      }
    }
    i.next {
      width: 50px;
      display: inline-block;
      text-align: center;
      color: $white;
      // float: left;
    }
  }
}

.column.moves {
  .tag.gen {
    margin: 2px;
    // margin-right:2px;
  }
}
</style>
